/**
 * Formats a number to a human-readable string (e.g., 1.2M, 500K)
 */
export function formatNumber(count: number | string | null | undefined): string {
  if (count === null || count === undefined) return '0';

  const num = typeof count === 'string' ? parseFloat(count) : count;

  if (isNaN(num)) return '0';

  if (num >= 1000000) {
    return (num / 1000000).toFixed(2).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return Math.round(num / 1000) + 'K';
  }
  return num.toString();
}

export function formatCompactNumber(value: number | null | undefined, decimalPlaces: number = 1): string {
  if (value === null || value === undefined) return '-';
  if (value === 0) return '0';

  const absValue = Math.abs(value);
  const sign = value < 0 ? '-' : '';

  if (absValue >= 1_000_000_000) {
    const formatted = (absValue / 1_000_000_000).toFixed(decimalPlaces);
    return `${sign}${formatted.replace(/\.0+$/, '').replace(/(\.[0-9]*[1-9])0+$/, '$1')}B`;
  }
  if (absValue >= 1_000_000) {
    const formatted = (absValue / 1_000_000).toFixed(decimalPlaces);
    return `${sign}${formatted.replace(/\.0+$/, '').replace(/(\.[0-9]*[1-9])0+$/, '$1')}M`;
  }
  if (absValue >= 1_000) {
    const formatted = (absValue / 1_000).toFixed(decimalPlaces);
    return `${sign}${formatted.replace(/\.0+$/, '').replace(/(\.[0-9]*[1-9])0+$/, '$1')}K`;
  }

  return `${sign}${absValue}`;
}

export function formatPercentage(value: number | null | undefined): string {
  if (value === null || value === undefined) return '-';
  return `${value.toFixed(2).replace(/\.?0+$/, '')}%`;
}

export function formatFullNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) return '-';
  return value.toLocaleString();
}
